import { createReducer } from '@reduxjs/toolkit';

export const initReducer = <T>(initialState: T) => createReducer<T>(initialState, {});
